import type { BlockerStatus, TaskPriority, TaskStatus } from '@mfos/shared';
import type { BadgeTone } from '../../components/Badge';

export const taskRef = (number: number) => `#${String(number)}`;

export const TASK_STATUS_DISPLAY: Readonly<Record<TaskStatus, { label: string; tone: BadgeTone }>> =
  {
    BACKLOG: { label: 'Backlog', tone: 'neutral' },
    PLANNED: { label: 'Planned', tone: 'info' },
    IN_PROGRESS: { label: 'In progress', tone: 'info' },
    BLOCKED: { label: 'Blocked', tone: 'down' },
    IN_REVIEW: { label: 'In review', tone: 'warn' },
    DONE: { label: 'Done', tone: 'ok' },
    ARCHIVED: { label: 'Archived', tone: 'neutral' },
    CANCELLED: { label: 'Cancelled', tone: 'neutral' },
  };

export const TASK_PRIORITY_DISPLAY: Readonly<
  Record<TaskPriority, { label: string; tone: BadgeTone }>
> = {
  LOW: { label: 'Low priority', tone: 'neutral' },
  NORMAL: { label: 'Normal priority', tone: 'neutral' },
  HIGH: { label: 'High priority', tone: 'warn' },
  CRITICAL: { label: 'Critical priority', tone: 'down' },
};

export const BLOCKER_STATUS_DISPLAY: Readonly<
  Record<BlockerStatus, { label: string; tone: BadgeTone }>
> = {
  OPEN: { label: 'Open blocker', tone: 'down' },
  RESOLVED: { label: 'Resolved', tone: 'ok' },
  CANCELLED: { label: 'Cancelled', tone: 'neutral' },
};
